'use strict';

var _basiclightbox = require('basiclightbox');

var basicLightbox = _interopRequireWildcard(_basiclightbox);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var self = {};

self.initialise = function () {
  var el = document.querySelectorAll('.js-btn-lightbox');

  if (!el) {
    return;
  }

  Array.from(el).forEach(function (item) {
    item.addEventListener('click', function (e) {
      var videoURLPath = item.dataset.video;
      var instance = basicLightbox.create('\n      <div class="responsive-wrapper">\n        <iframe src=\'' + videoURLPath + '?autoplay=1\' frameborder="0"></iframe>\n      </div>\n      ', {
        afterShow: function afterShow() {
          // initialiseVideo();
        }
      });

      instance.show(function () {
        document.querySelector('.basicLightbox').innerHTML += '\n        <div class="close-lightbox-wrapper">\n          <button class="btn--close js-close-lightbox">\n            <svg class="icon-svg icon-close" viewBox="0 0 50 50">\n              <use xlink:href="/src/img/svg/icon-close.svg#icon-close" />\n            </svg>\n          </button>\n        </div>\n        ';

        document.querySelector('.js-close-lightbox').addEventListener('click', function () {
          instance.close();
        });
      });

      e.preventDefault();
      instance.show();
    });
  });
};

module.exports = self;


// WEBPACK FOOTER //
// ./sitefiles/scripts/global/rebuild-components/init-lightbox.js